import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

// Tip tanımlamaları
interface FavoriteCoin {
  coinId: string;
  symbol: string;
  name: string;
  addedAt: Date;
}

interface FavoriteContextType {
  favoriteCoins: FavoriteCoin[];
  addToFavorites: (coin: { id: string; symbol: string; name: string }) => Promise<void>;
  removeFromFavorites: (coinId: string) => Promise<void>;
  isFavorite: (coinId: string) => boolean;
  loading: boolean;
}

const FavoriteContext = createContext<FavoriteContextType | undefined>(undefined);

export const FavoriteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [favoriteCoins, setFavoriteCoins] = useState<FavoriteCoin[]>([]);
  const [loading, setLoading] = useState(false);
  const { isAuthenticated } = useAuth();

  // Favori coinleri getir
  const fetchFavorites = async () => {
    if (!isAuthenticated) return;

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get('http://31.210.36.47:5002/api/favorites', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setFavoriteCoins(response.data);
    } catch (error) {
      console.error('Favoriler getirilirken hata:', error);
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    } finally {
      setLoading(false);
    }
  };

  // Kullanıcı girişi yapıldığında favorileri getir
  useEffect(() => {
    if (isAuthenticated) {
      fetchFavorites();
    } else {
      setFavoriteCoins([]);
    }
  }, [isAuthenticated]);

  // Favorilere coin ekle
  const addToFavorites = async (coin: { id: string; symbol: string; name: string }) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'http://31.210.36.47:5002/api/favorites/add',
        {
          coinId: coin.id,
          symbol: coin.symbol,
          name: coin.name
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      setFavoriteCoins(response.data);
    } catch (error) {
      console.error('Favorilere eklenirken hata:', error);
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      throw error;
    }
  };

  // Favorilerden coin kaldır
  const removeFromFavorites = async (coinId: string) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.delete(
        `http://31.210.36.47:5002/api/favorites/remove/${coinId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      setFavoriteCoins(response.data);
    } catch (error) {
      console.error('Favorilerden kaldırılırken hata:', error);
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      throw error;
    }
  };

  // Coin favori mi kontrol et
  const isFavorite = (coinId: string) => {
    return favoriteCoins.some(coin => coin.coinId === coinId);
  };

  return (
    <FavoriteContext.Provider value={{
      favoriteCoins,
      addToFavorites,
      removeFromFavorites,
      isFavorite,
      loading
    }}>
      {children}
    </FavoriteContext.Provider>
  );
};

// Hook
export const useFavorites = () => {
  const context = useContext(FavoriteContext);
  if (context === undefined) {
    throw new Error('useFavorites must be used within a FavoriteProvider');
  }
  return context;
};

export default FavoriteProvider;